import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    IconButton,
} from "@mui/material";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../../../../styles/customScrollbar.css";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { useState } from "react";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";

const CourseContent = ({
    courseData,
    onVideoSelect,
    courseDocData,
    purchase,
}: any) => {
    const [isContentVisible, setIsContentVisible] = useState(true);

    const toggleContentVisibility = () => {
        setIsContentVisible(!isContentVisible);
    };
    const handleVideoClick = (video: { url: string; type: string }) => {
        onVideoSelect(video);
    };

    const handleFileClick = (file: { url: string; type: string }) => {
        onVideoSelect(file);
    };
    return (
        <Box
            width={isContentVisible ? { xs: "300px", md: "450px" } : "44px"}
            height={{ xs: "587px", md: "587px" }}
        >
            <Box
                display={"flex"}
                p={isContentVisible ? 2 : 1}
                justifyContent={"space-between"}
                alignItems={"center"}
            >
                {isContentVisible ? (
                    <>
                        <Typography fontSize={"20px"} fontWeight={700} color={"#5C5C5C"}>
                            Course content
                        </Typography>
                        <ClearOutlinedIcon
                            sx={{ color: "gray", cursor: "pointer", mr: 2 }}
                            onClick={toggleContentVisibility}
                        />
                    </>
                ) : (
                    <KeyboardDoubleArrowLeftIcon
                        sx={{ color: "gray", cursor: "pointer" }}
                        onClick={toggleContentVisibility}
                    />
                )}
            </Box>
            {isContentVisible && (
                <Box
                    className="custom-scrollbar"
                    p={{ xs: "5px", md: 1 }}
                    sx={{ maxHeight: "500px", overflowY: "scroll" }}
                >
                    {purchase?.contentData?.contentStructure?.map(
                        (section: any, sectionIndex: number) => (
                            <Accordion
                                key={sectionIndex}
                                defaultExpanded
                                sx={{ backgroundColor: "#F3F3F3", mb: 1 }}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography
                                        fontSize={"18px"}
                                        fontWeight={700}
                                        color={"#233F91"}
                                    >
                                        {section?.title}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ py: 0, display: "flex", gap: 3 }}>
                                    <List>
                                        {section?.files?.map((file: any, fileIndex: number) => (
                                            <ListItem
                                                key={fileIndex}
                                                sx={{ pl: 0, cursor: "pointer" }}
                                                onClick={() => handleFileClick(file)}
                                            >
                                                <ListItemIcon sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                                    {file.type === "pdf" || file.type === "image" ? (
                                                        <InsertDriveFileIcon sx={{ color: "#595959" }} />
                                                    ) : (
                                                        <PlayCircleOutlineIcon sx={{ color: "#595959" }} />
                                                    )}
                                                    <ListItemText
                                                        sx={{
                                                            color: "#595959",
                                                            fontSize: { xs: "14.96px", md: "18px" },
                                                            fontWeight: 400,
                                                        }}
                                                        primary={file.name} // Display the name of the file
                                                    />
                                                </ListItemIcon>

                                            </ListItem>
                                        ))}
                                    </List>
                                </AccordionDetails>

                            </Accordion>
                        )
                    )}

                    {/* {courseDocData.map((section: any, sectionIndex: any) => (
                        <Accordion key={sectionIndex} defaultExpanded sx={{ backgroundColor: "#F3F3F3", mb: 1 }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontSize={{ xs: "14.96px", md: "18px" }} fontWeight={700} color={"#233F91"}>
                                    {section.section}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ py: 0, display: "flex", gap: 3 }}>
                                <List>
                                    {section.files.map((file: any, fileIndex: any) => (
                                        <ListItem key={fileIndex} sx={{ pl: 0, cursor: "pointer" }} onClick={() => handleFileClick({ url: file.url, type: file.type })}>
                                            <ListItemIcon sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                                {file.type === "pdf" ? (
                                                    <InsertDriveFileIcon sx={{ color: "#595959" }} />
                                                ) : (
                                                    <PlayCircleOutlineIcon sx={{ color: "#595959" }} />
                                                )}
                                                <ListItemText sx={{ width: "140px" }} primary={file.title} />

                                            </ListItemIcon>
                                            <Box sx={styleSheet.downloadIconButton}>
                                                <IconButton aria-label="download" href={file.url} download
                                                    sx={styleSheet.downloadBtn}
                                                >
                                                    <img src="/assets/icons/downloadhandout.png" alt="download"
                                                    />
                                                </IconButton>
                                            </Box>

                                        </ListItem>
                                    ))}
                                </List>
                            </AccordionDetails>
                        </Accordion>
                    ))}

                    {[...Array(10)].map((_, index) => (
                        <Accordion key={index} defaultExpanded sx={{ backgroundColor: "#F3F3F3", mb: 1 }}>
                            <AccordionSummary sx={{ py: 1 }} expandIcon={<ExpandMoreIcon />}>
                                <Typography fontSize={{ xs: "14.96px", md: "18px" }} fontWeight={700} color={"#233F91"}>
                                    Definition and Scope of Psychology
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="body2">
                                    Detailed content description here...
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))} */}
                </Box>
            )}
        </Box>
    );
};

export default CourseContent;

const styleSheet = {
    downloadBtn: {
        width: "24px",
        height: "24px",
    },
    downloadIconButton: {
        display: "flex",
        alignItems: "center",
    },
};
